/* Progressive enhancements. Links, search and product forms have native fallbacks. */
(() => {
  'use strict';
  function initialise(root = document) {
    root.querySelectorAll('[data-cbc-details]').forEach((details) => {
      if (details.dataset.cbcReady) return;
      details.dataset.cbcReady = 'true';
      details.addEventListener('toggle', () => {
        const summary = details.querySelector(':scope > summary');
        if (summary) summary.setAttribute('aria-expanded', String(details.open));
        if (!details.open) return;
        const navigation = details.closest('nav');
        if (!navigation) return;
        navigation.querySelectorAll('[data-cbc-details][open]').forEach((other) => {
          if (other !== details && !other.contains(details)) other.open = false;
        });
      });
    });
    root.querySelectorAll('[data-cbc-mobile]').forEach((menu) => {
      if (menu.dataset.cbcReady) return;
      menu.dataset.cbcReady = 'true';
      const summary = menu.querySelector(':scope > summary');
      menu.addEventListener('toggle', () => {
        if (summary) summary.setAttribute('aria-expanded', String(menu.open));
        if (menu.open) {
          const panel = menu.querySelector('.cbc-mobile-panel');
          if (panel) panel.style.setProperty('--cbc-menu-height', `${Math.max(160, window.innerHeight - panel.getBoundingClientRect().top - 12)}px`);
        }
      });
      menu.querySelector('[data-cbc-close-menu]')?.addEventListener('click', () => {
        menu.open = false;
        summary?.focus();
      });
    });
    // Give existing layout tables a keyboard-accessible horizontal scroll region.
    root.querySelectorAll('.rte table').forEach((table) => {
      if (table.scrollWidth > table.clientWidth && !table.hasAttribute('tabindex')) {
        table.tabIndex = 0;
        if (!table.hasAttribute('aria-label')) table.setAttribute('aria-label', 'Tabel: horizontaal scrollen mogelijk');
      }
    });
    // Correct legacy empty mailto links without replacing text or policy contents.
    root.querySelectorAll('a[href="mailto:<empty>"]').forEach((a) => {
      const address = a.textContent.trim();
      if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(address)) a.href = `mailto:${address}`;
    });
    root.querySelectorAll('a[target="_blank"]').forEach((a) => {
      a.rel = [...new Set(`${a.rel} noopener noreferrer`.trim().split(/\s+/))].join(' ');
    });
  }
  document.addEventListener('click', (event) => {
    if (!(event.target instanceof Element)) return;
    document.querySelectorAll('[data-cbc-details][open]').forEach((details) => {
      if (!details.contains(event.target)) details.open = false;
    });
    document.querySelectorAll('[data-cbc-mobile][open]').forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    const active = document.activeElement;
    const details = active?.closest('[data-cbc-details][open]') || document.querySelector('[data-cbc-details][open]');
    if (details) {
      details.open = false;
      details.querySelector(':scope > summary')?.focus();
      event.preventDefault();
      return;
    }
    const menu = document.querySelector('[data-cbc-mobile][open]');
    if (menu) {
      menu.open = false;
      menu.querySelector(':scope > summary')?.focus();
      event.preventDefault();
    }
  });
  window.matchMedia('(min-width:1280px)').addEventListener('change', (e) => {
    if (e.matches) document.querySelectorAll('[data-cbc-mobile][open]').forEach((menu) => { menu.open = false; });
  });
  document.addEventListener('shopify:section:load', (e) => initialise(e.target));
  document.addEventListener('shopify:section:unload', () => {
    document.querySelectorAll('[data-cbc-mobile][open]').forEach((menu) => { menu.open = false; });
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise());
  else initialise();
})();
